module.exports = __webpack_public_path__ + "img/advice-6.549bf3de.png";